import React, { useEffect, useState } from "react";

// Redux
import { Link } from "react-router-dom";
import { Row, Col, CardBody, Card, Container, Form, FormFeedback, Alert } from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector } from "react-redux";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/dofy-logo.png";
import lightlogo from "../../assets/images/dofy-logo.png";

import withRouter from "components/Common/withRouter";
import { createSelector } from 'reselect';
import { useNavigate } from 'react-router-dom';
import { aes_decryption, getTokenDetail, HandleHomepage, isIn } from "../../helpers/Helper";

import CommonService from "services/CommonService";
import { HelperConstant } from "../../helpers/HelperConstant";
import { CustomPasswordBox } from "components/shared/CustomPasswordBox";
import { CustomPhoneNumberBox } from "components/shared/CustomPhoneNumberBox";
import OtpInput from "react-otp-input-rc-17";
import { useTypedDispatch, useTypedSelector } from "features/reduxhooks/ReduxHooks";
import { TemporaryPassword } from "features/reducers/otp/Otp.Reducers";
import { IloginModel } from "models/Login.Model";
import { UserNameData } from "features/reducers/username/UserName.Reducers";
import { getDecodedAccessToken } from "../../helpers/TokenHelper";
import PersonService from "services/Person.Service";
import CustomLoader from "components/Common/CustomLoader";
import { setCaptchaTokenHeader } from "services/http-common";
import { executeRecaptchaV3 } from "../../helpers/recaptchaV3";


const Login = (props: any) => {
  const dispatch = useTypedDispatch()
  const [showLoading, setShowLoading] = useState(false);
  const navigate = useNavigate();
  const [otp, setOtp] = useState("")
  const [errorOTP, setErrorOTP] = useState<boolean>(false);
  const [counter, setCounter] = useState(HelperConstant.otpVerificationTime.timer);
  const [AuthorizedUser, setAuthorizedUser] = useState<boolean>(false);
  const [isAuthUserName, setIsAuthUserName] = useState<boolean>(false);
  const [whenEntered, setWhenEntered] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [captchaSiteKey, setCaptchaSiteKey] = useState<string>("");
  const [captchaEnabled, setCaptchaEnabled] = useState<boolean>(true);
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const [apiError, setApiError] = useState<string>("");

  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => {
        if (data?.RECAPTCHA_SITE_KEY) {
          setCaptchaSiteKey(data.RECAPTCHA_SITE_KEY);
        }
        if (data?.RECAPTCHA_ENABLED !== undefined) {
          setCaptchaEnabled(data.RECAPTCHA_ENABLED === true || data.RECAPTCHA_ENABLED === "true");
        }
      })
      .catch((err) => console.log(err));
  }, []);

  //meta title
  document.title = "Login | DOFY-Admin";

  const selectProperties = createSelector(
    (state: any) => state.Login,
    (error) => error
  );

  const { error } = useSelector(selectProperties);
  let UserNameValue = useTypedSelector(state => state?.UserNameReducers?.UserNameInfoData);


  const getInitialPath = () => {
    const groupedMenuList = JSON.parse(localStorage.getItem("GroupedMenuList") as any);
    const mappedValues = Object.keys(groupedMenuList)
      .map((typeName: string) => {
        if (typeName === "Orders") {
          return "/orders";
        }
        return groupedMenuList[typeName]?.filter(
          (item: any) => item.ActivityMasterId === 1 && item.HasAccess === true
        )[0]?.Path;
      })
      .filter((value) => value !== undefined);
    return mappedValues[0];
  }


  // Form validation 
  const validation: any = useFormik<IloginModel>({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      UserName: '',
      PassWord: isIn() ? "1234" : '',
    },
    validationSchema: Yup.object({
      UserName: Yup.string().required("Please Enter Phone Number"),
      PassWord: Yup.string().required("Please Enter Password"),
    }),
    onSubmit: (values: any) => {
      isIn() ? authenticateForIN(values.UserName, values.PassWord) : authenticateForAE(values.UserName, values.PassWord);
      // dispatch(loginuser(values, navigate));
    }
  });

  const authenticateForIN = async (mobileNumber, password) => {
    setApiError("");
    try {
      setShowLoading(true);
      if (captchaSiteKey && captchaEnabled) {
        const v3Token = await executeRecaptchaV3(captchaSiteKey, "admin_signin", captchaEnabled);
        if (v3Token) {
          setCaptchaTokenHeader(v3Token);
        }
      }
      const res = await CommonService.getWithSingleEntity("auth", "SignIn", mobileNumber).then(res => {
        if (res.status === 200) {
          if (res.data === "Not Valid User" || res.data === "Invalid Credentials") {
            return setAuthorizedUser(true);
          } else {
            setAuthorizedUser(false);
            setIsAuthUserName(true)
            dispatch(UserNameData(mobileNumber));
          }
        }
        setShowLoading(false);
        setLoading(true);
      }).catch(e => {
        console.log(e);
        setApiError(e?.response?.data || e?.message || "Something went wrong");
      })
    } catch (error) {
      setShowLoading(false);
      console.log(error);
    } finally {
      setShowLoading(false);
    }
  }

  const authenticateForAE = async (mobileNumber, password) => {
    setApiError("");
    try {
      setShowLoading(true);
      if (captchaSiteKey && captchaEnabled) {
        const v3Token = await executeRecaptchaV3(captchaSiteKey, "admin_emailauth", captchaEnabled);
        if (v3Token) {
          setCaptchaTokenHeader(v3Token);
        }
      }
      const res = await CommonService.postWithDoubleEntity("auth", "emailauthenticate", mobileNumber, password).then(res => {
        if (res.status === 200) {
          if (res.data === "Not Valid User" || res.data === "Invalid Credentials") {
            return setAuthorizedUser(true);
          }
          localStorage.setItem('authUser', JSON.stringify(res.data));
          localStorage.setItem('loginId', res.data);
          // HandleHomepage(res.data.Token);
          getUserMenuList(res.data.Token);

        }
      }).catch(e => {
        console.log(e);
        setApiError(e?.response?.data || e?.message || "Something went wrong");
      })
    } catch (error) {
      setShowLoading(false);
      console.log(error);
    } finally {
      setShowLoading(false);
    }
  }

  const handleOtpChange = (value) => {
    setOtp(value);
    setErrorOTP(false)
    setWhenEntered(true);
    if (whenEntered && value.length === 6) {
      authentication(value);
    }
  }

  const getUserMenuList = (authToken: any) => {
    PersonService.GetMenuAccess(0, authToken)
      .then((res) => {
        if (res.status === 200) {
          const decryptedData = aes_decryption(res.data);
          const menuData = JSON.parse(decryptedData);
          const groupedMenuList = menuData.reduce((acc: any, menuItem: any) => {
            acc[menuItem.ScreenTypeName] = acc[menuItem.ScreenTypeName] || [];
            acc[menuItem.ScreenTypeName].push(menuItem);
            return acc;
          }, {});

          localStorage.setItem("GroupedMenuList", JSON.stringify(groupedMenuList));

          const ordersPath = groupedMenuList["Orders"]?.find(
            (item: any) => item.ActivityMasterId === 1 && item.HasAccess === true
          )?.Path;

          if (ordersPath) {
            window.location.href = "/homepage";
            return;
          }

          const mappedValues = Object.keys(groupedMenuList)
            .map((typeName: string) => {
              return groupedMenuList[typeName]?.find(
                (item: any) => item.ActivityMasterId === 1 && item.HasAccess === true
              )?.Path;
            })
            .filter((value) => value !== undefined);

          if (mappedValues.length > 0) {
            window.location.href = mappedValues[0];
          }
        }
      })
      .catch(e => {
        if (e == 'Request failed with status code 401') {
          navigate('/logout')
        } else {
          console.error("API error:", e);
        }
      })
  };


  const authentication = async (value) => {
    setApiError("");
    try {
      setShowLoading(true)
      if (captchaSiteKey && captchaEnabled) {
        const v3Token = await executeRecaptchaV3(captchaSiteKey, "admin_authenticate", captchaEnabled);
        if (v3Token) {
          setCaptchaTokenHeader(v3Token);
        }
      }
      dispatch(TemporaryPassword(value))
      const res = await CommonService.postWithDoubleEntity("auth", "authenticate", UserNameValue, value).then(res => {
        if (res.status === 200) {
          if (res.data === 'Invalid Credentials') {
            setErrorOTP(true);
          } else {
            localStorage.setItem('authUser', JSON.stringify(res.data));
            localStorage.setItem('loginId', res.data);
            getUserMenuList(res.data.Token);

          }
        }
      })
    } catch (error: any) {
      console.log(error);
      setApiError(error?.response?.data || error?.message || "Something went wrong");
      setShowLoading(false);
    } finally {
      setShowLoading(false);
    }

  }

  const reset = async () => {
    setApiError("");
    setCounter(HelperConstant.otpVerificationTime.timer);
    if (captchaSiteKey && captchaEnabled) {
      const v3Token = await executeRecaptchaV3(captchaSiteKey, "admin_resendotp", captchaEnabled);
      if (v3Token) {
        setCaptchaTokenHeader(v3Token);
      }
    }
    CommonService.getWithSingleEntity("auth", "ResendOTP", UserNameValue).then(res => {
      if (res.status === 200) {
        getResendButton();
      }
    }).catch((e: any) => {
      console.log(e);
      setApiError(e?.response?.data || e?.message || "Something went wrong");
    });
  }

  const getResendButton = () => {
    if (counter > 0) {
      return "text-muted";
    }
    else {
      return "text-info";
    }
  }
  const getResendButtonHide = () => {
    if (counter === 0) {
      return "ion-hide";
    }
    else {
      return "vs-resend-hidden";
    }
  }


  useEffect(() => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter]);

  // useEffect(() => {
  //   if (error) {
  //     setTimeout(() => {
  //       dispatch(resetLoginMsgFlag())
  //     }, 3000);
  //   }
  // }, [dispatch, error])

  // useEffect(() => {
  //   if (getTokenDetail()?.PersonId) {
  //     getInitialPath()
  //   }
  // }, [])

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden p-0">
                <div className="bg-dofy p-0">
                  <Row>
                    <Col className="col-7">
                      <div className="text-white p-4">
                        <h5 className="text-white fw-semibold">Welcome Back !</h5>
                        <p className="text-white">Sign in to continue to DOFY.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div className="auth-logo">
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={lightlogo}
                            alt=""
                            className="rounded-circle"
                            height="42"
                          />
                        </span>
                      </div>
                    </Link>
                    <Link to="/" className="auth-logo-dark">
                      <div className="avatar-md profile-user-wid">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="42"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>

                  <div className="p-2">
                    {isIn() ?
                      <>
                        <div>
                          {(AuthorizedUser && !error.PassWord) &&
                            <div className='mt-3' style={AuthorizedUser ? { marginBottom: '-20px' } : { marginBottom: 'none' }}>
                              <Alert
                                color="warning"
                                className="fade show"
                                role="alert"
                              >
                                <i className="mdi mdi-alert-outline me-2"></i>
                                Please check the Mobile Number
                              </Alert>
                            </div>
                          }
                          {errorOTP &&
                            <div className='mt-3' style={AuthorizedUser ? { marginBottom: '-20px' } : { marginBottom: 'none' }}>
                              <Alert
                                color="warning"
                                className="fade show"
                                role="alert"
                              >
                                <i className="mdi mdi-alert-outline me-2"></i>
                                Invalid OTP
                              </Alert>
                            </div>
                          }
                          {apiError &&
                            <div className='mt-3' style={{ marginBottom: '-20px' }}>
                              <Alert
                                color="danger"
                                className="fade show"
                                role="alert"
                              >
                                <i className="mdi mdi-alert-outline me-2"></i>
                                {apiError}
                              </Alert>
                            </div>
                          }
                        </div>
                        <Form className="form-horizontal"
                          onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                          }}
                        >
                          {!isAuthUserName ?
                            <div className="mb-3">
                              {error ? <Alert color="danger">{error}</Alert> : null}
                              <CustomPhoneNumberBox
                                name="UserName"
                                className="form-control"
                                placeholder="Enter Mobile Number"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.UserName || ""}
                                invalid={validation.touched.UserName && validation.errors.UserName ? true : false}
                                label={'Mobile Number'}
                                id={'UserName'}
                                error={undefined}
                                numberCode={'+91'}
                                isMandatory={true}
                              />
                              {validation.touched.UserName && validation.errors.UserName ? (
                                <FormFeedback type="invalid">{validation.errors.UserName}</FormFeedback>
                              ) : null}
                            </div> : <></>}
                          {isAuthUserName ?
                            <>
                              <p className="fw-semibold font-size-15 text-center">Verify OTP</p>
                              <OtpInput
                                isInputNum
                                value={otp}
                                onChange={(e) => handleOtpChange(e)}
                                numInputs={6}
                                className="os_Input-align my-2"
                                shouldAutoFocus
                                focusStyle={{ border: "2.5px solid #1E4496" }}
                              />

                              <div className="mt-3 d-flex justify-content-center">
                                <p onClick={() => reset()} className={`${getResendButton()} cursor-pointer m-0`} >Resend OTP</p>
                              </div>
                              <div className="mt-2 text-center">
                                <p className="text-info font-size-12">Resend OTP in Seconds : {counter}</p>
                              </div>
                            </> : null}
                          {!isAuthUserName ?
                            <div className="mt-3 d-grid">
                              <button
                                type="submit" className={"btn btn-primary btn-block"}>
                                {loading ?
                                  <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i> : null}{loading ? "Loading..." : "Sign In"}</button>
                              {/* Sign In */}

                            </div> : null}

                        </Form>
                      </> :
                      <>
                        <div>
                          {(AuthorizedUser && !error.password && !error.UserName) &&
                            <div className='mt-3' style={AuthorizedUser ? { marginBottom: '-20px' } : { marginBottom: 'none' }}>
                              <Alert
                                color="warning"
                                className="fade show"
                                role="alert"
                              >
                                <i className="mdi mdi-alert-outline me-2"></i>
                                Please check the Mobile Number and Password
                              </Alert>
                            </div>
                          }
                          {apiError &&
                            <div className='mt-3' style={{ marginBottom: '-20px' }}>
                              <Alert
                                color="danger"
                                className="fade show"
                                role="alert"
                              >
                                <i className="mdi mdi-alert-outline me-2"></i>
                                {apiError}
                              </Alert>
                            </div>
                          }
                        </div>
                        <Form className="form-horizontal"
                          onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                          }}
                        >

                          <div className="mb-3">
                            {error ? <Alert color="danger">{error}</Alert> : null}
                            <CustomPhoneNumberBox
                              name="UserName"
                              className="form-control"
                              placeholder="Enter Mobile Number"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.UserName || ""}
                              invalid={validation.touched.UserName && validation.errors.UserName ? true : false}
                              label={'Mobile Number'}
                              id={'UserName'}
                              error={undefined}
                              numberCode={'+971'}
                              isMandatory={true}
                            />
                            {validation.touched.UserName && validation.errors.UserName ? (
                              <FormFeedback type="invalid">{validation.errors.UserName}</FormFeedback>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <div className="input-group auth-pass-inputgroup">
                              <CustomPasswordBox
                                name="PassWord"
                                value={validation.values.PassWord || ""}
                                placeholder="Enter Password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={validation.touched.PassWord && validation.errors.Password ? true : false}
                                label={"Password"}
                                id={'PassWord'}
                                isMandatory={true}
                                error={undefined} />
                            </div>
                            {validation.touched.PassWord && validation.errors.PassWord ? (
                              <FormFeedback type="invalid">{validation.errors.PassWord}</FormFeedback>
                            ) : null}
                          </div>
                          <div className="mt-3 d-grid">
                            <button
                              className="btn btn-primary btn-block "
                              type="submit"
                            >
                              Sign In
                            </button>
                          </div>

                        </Form>
                      </>}

                    <div className="mt-3 d-flex justify-content-center">
                      <Link to={"/country-section"}>Change Country</Link>
                    </div>
                  </div>
                  <div className="mt-2 text-center">
                    <p className="font-size-11 text-muted">
                      © {new Date().getFullYear()} Invent Softlabs (India)
                      Private Limited.
                    </p>
                  </div>
                </CardBody>
              </Card>

            </Col>
          </Row>
        </Container>
        <CustomLoader isOpen={showLoading} />
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);
